module.exports = __webpack_public_path__ + "img/developers-icon-active.d3dde84d.svg";